import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getNonceProps, loadScriptSecurely, executeScriptSecurely } from '@/utils/secureWeb3Provider';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const GoogleAnalytics = ({ measurementId }: { measurementId: string }) => {
  const location = useLocation();
  const scriptRefs = useRef<HTMLScriptElement[]>([]);

  useEffect(() => {
    const initGA = async () => {
      try {
        // Initialize dataLayer globally
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        
        // Load GTM script with proper nonce
        await loadScriptSecurely(`https://www.googletagmanager.com/gtag/js?id=${measurementId}`);
        
        // Initialize GA with proper nonce
        const initCode = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `;
        executeScriptSecurely(initCode);
        
        // Track page view
        gtag('config', measurementId, {
          page_path: location.pathname + location.search,
        });
      } catch (error) {
        console.error('Error initializing Google Analytics:', error);
      }
    };

    initGA();
    
    // No need for cleanup as our loadScriptSecurely handles nonces correctly
  }, [location, measurementId]);

  return null;
};
